import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createProject, type CreateProjectInput, type CreatedProject } from '../api/create-project'

export function useCreateProjectMutation(opts?: {
  onSuccess?: (project: CreatedProject) => void
  onError?: (err: Error) => void
}) {
  const queryClient = useQueryClient()
  return useMutation<CreatedProject, Error, CreateProjectInput>({
    mutationFn: createProject,
    onSuccess: (project) => {
      queryClient.invalidateQueries({ queryKey: ['admin-projects'] })
      queryClient.invalidateQueries({ queryKey: ['my-projects'] })
      opts?.onSuccess?.(project)
    },
    onError: (err) => {
      opts?.onError?.(err)
    },
  })
}
